import CalculateMembershipRequestModelBase from '../_generated/modelBases/calculate-membership-request-model-base';

export default class CalculateMembershipRequestModel extends CalculateMembershipRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
